/* Loaded by more than one section on a page (main-product plus the
   add-to-cart section), so a second load must be a no-op rather than an
   "Identifier 'ProductForm' has already been declared" SyntaxError. */
(() => {
if (customElements.get('product-form')) return;

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    this.hideErrors = this.dataset.hideErrors === 'true';

    /* A form can ship without a variant input — the add-to-cart section in
       kit-only mode builds items[] from its checkboxes instead. */
    const variantInput = this.querySelector('[name=id]');
    if (variantInput) variantInput.disabled = false;

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    } else {
      this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
    }

    if (document.querySelector('cart-drawer')) {
      this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
  }

  onSubmitHandler(e) {
    e.preventDefault();

    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form || undefined);
    if (!this.form) {
      formData.append('id', this.querySelector('[name=id]').value);
    }

    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((s) => s.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: data.description,
            message: data.message,
          });

          this.handleErrorMessage(data.description);

          const soldOut = this.submitButton.querySelector('.sold-out-message');
          if (soldOut) {
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOut.classList.remove('hidden');
            this.error = true;
          }
          return;
        }

        if (this.cart) {
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
            });
          }

          this.error = false;

          const modal = this.closest('quick-add-modal');
          if (modal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => this.cart.renderContents(data));
              },
              { once: true }
            );
            modal.hide(true);
          } else {
            this.cart.renderContents(data);
          }
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(console.error)
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart?.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(error = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;

    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !error);

    if (error) {
      this.errorMessage.textContent = error;
    }
  }
}

customElements.define('product-form', ProductForm);

})();
